import Lottie from 'lottie-react';

import styles from './AnimatedIcon.module.css';

interface AnimatedIconProps {
    animationData: Record<string, unknown>;
    loop?: boolean;
    autoplay?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

export const AnimatedIcon = ({
    animationData,
    loop = true,
    autoplay = true,
    className,
    style,
}: AnimatedIconProps) => {
    return (
        <div
            className={`${styles.container}${className ? ` ${className}` : ''}`}
            style={style}
        >
            <Lottie
                animationData={animationData}
                loop={loop}
                autoPlay={autoplay}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};
